<div class="severity">
  <ds-chip
    [text]="'scan_issue_severity_' + severity | translate"
    [colorVariant]="getSeverityChipVariant(severity)"
    [showIcon]="true"
    [iconPosition]="DsChipIconPosition.Left"
    [iconStyle]="IconStyles.Regular"
    [iconName]="getSeverityIcon(severity)"
    [iconColor]="getSeverityIconColor(severity)"
  ></ds-chip>
</div>
